/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsSyncThreadChart,
    AssetsMelcoModelsSyncThreadChartFromJSON,
    AssetsMelcoModelsSyncThreadChartToJSON,
} from '../models';

export interface SyncThreadsApiSyncAssetDownloadThreadRequest {
    id: string;
}

export interface SyncThreadsApiSyncAssetThreadsRequest {
    version?: number;
    productList?: string;
}

/**
 * 
 */
export class SyncThreadsApi extends runtime.BaseAPI {

    /**
     */
    async syncAssetDownloadThreadRaw(requestParameters: SyncThreadsApiSyncAssetDownloadThreadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling syncAssetDownloadThread.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sync/assets/threads/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async syncAssetDownloadThread(requestParameters: SyncThreadsApiSyncAssetDownloadThreadRequest): Promise<Blob> {
        const response = await this.syncAssetDownloadThreadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async syncAssetThreadsRaw(requestParameters: SyncThreadsApiSyncAssetThreadsRequest): Promise<runtime.ApiResponse<Array<AssetsMelcoModelsSyncThreadChart>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sync/assets/threads`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetsMelcoModelsSyncThreadChartFromJSON));
    }

    /**
     */
    async syncAssetThreads(requestParameters: SyncThreadsApiSyncAssetThreadsRequest): Promise<Array<AssetsMelcoModelsSyncThreadChart>> {
        const response = await this.syncAssetThreadsRaw(requestParameters);
        return await response.value();
    }

}
